var map = {
	"./ar/search/index.vue": [
		938,
		938
	],
	"./en/search/index.vue": [
		604,
		604
	],
	"./fa/search/index.vue": [
		2745,
		745
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9841;
module.exports = webpackAsyncContext;